import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

declare global {
    interface Window {
        clarity: ((...args: unknown[]) => void) & { q?: unknown[][] };
    }
}

@Injectable({
    providedIn: 'root',
})
export class ClarityService {
    setup() {
        if (!environment.CLARITY_KEY) {
            return;
        }
        this.createScript(environment.CLARITY_KEY);
    }

    private createScript(clarityKey: string) {
        window.clarity =
            window.clarity ||
            function (...args: unknown[]) {
                (window.clarity.q = window.clarity.q || []).push(args);
            };
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.clarity.ms/tag/${clarityKey}`;
        document.head.appendChild(script);
    }
}
